import { render, staticRenderFns } from "./ChildrenInfo.vue?vue&type=template&id=66e0d49c&scoped=true"
import script from "./ChildrenInfo.vue?vue&type=script&lang=ts"
export * from "./ChildrenInfo.vue?vue&type=script&lang=ts"
import style0 from "./ChildrenInfo.vue?vue&type=style&index=0&id=66e0d49c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0d49c",
  null
  
)

export default component.exports